import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import SortableTableCell from '@eogile/agrements-common/src/components/table/SortableTableCell';
import { PaginationAndSortCommand } from '@eogile/agrements-common/src/components/table/tableTypes';
import { PmuUsersSortableFields } from '../pmuUsersTypes';

type Props = {
  onCommandChange: (newCommand: PaginationAndSortCommand<PmuUsersSortableFields>) => void;
  command: PaginationAndSortCommand<PmuUsersSortableFields>;
};

const PmuUsersTableHeader = ({ onCommandChange, command }: Props) => {
  return (
    <TableHead>
      <TableRow>
        <SortableTableCell<PmuUsersSortableFields>
          label="Login"
          sortField="LOGIN"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<PmuUsersSortableFields>
          label="Nom"
          sortField="LAST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<PmuUsersSortableFields>
          label="Prénom"
          sortField="FIRST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<PmuUsersSortableFields>
          label="Email"
          sortField="EMAIL"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<PmuUsersSortableFields>
          label="Zone de vente"
          sortField="AGENCY_CODE"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Rôles</TableCell>
        <SortableTableCell<PmuUsersSortableFields>
          label="Date maj"
          sortField="UPDATED_AT"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default PmuUsersTableHeader;
